export enum CategoryGroupKey {
  BEFORE_FAVORITES = 'before-favorites',
  AFTER_FAVORITES = 'after-favorites',
  OTHER_CATEGORIES = 'other-categories',
  MORE_CATEGORIES = 'more-categories',
}

/** Lobby page & `useGroupCategories` — order matches layout sections */
export const LOBBY_CATEGORY_GROUP_KEYS = [
  CategoryGroupKey.BEFORE_FAVORITES,
  CategoryGroupKey.AFTER_FAVORITES,
  CategoryGroupKey.OTHER_CATEGORIES,
  CategoryGroupKey.MORE_CATEGORIES,
] as const;

/** Global sidebar: same flow without the “more categories” swiper group */
export const SIDEBAR_CATEGORY_GROUP_KEYS = [
  CategoryGroupKey.BEFORE_FAVORITES,
  CategoryGroupKey.AFTER_FAVORITES,
  CategoryGroupKey.OTHER_CATEGORIES,
] as const;
